import { IResourceType } from '../types/IResourceType'
import { AccessLevel } from '../types/AccessLevel'
import { IResourceTypeIcon } from '../types/IResourceTypeIcon'
import { IResourceTypeComponents } from '../types/IResourceTypeComponents'
import { Sample } from './Sample'
import { AlreadyInCartType } from '../types/helperTypes'
import { ICartItem } from '../types/ICartItem'
import { IResource } from '../types/IResource'
import { RESOURCE_TYPE_NAMES } from 'utils'

export class BusinessRoleType implements IResourceType {
    name = RESOURCE_TYPE_NAMES.BUSINESS_ROLES

    route = '/businessRoles'

    title = 'Common_BusinessRoles'

    access: AccessLevel = {
        page: 'ITShop-BusinessRoles-Page',
    }

    icon: IResourceTypeIcon = {
        small: 'BusinessRolesSmall',
        large: 'BusinessRolesLarge',
    }

    manageAccessComponents: IResourceTypeComponents = {
        cardComponent: Sample,

        rowComponent: Sample,

        detailComponent: Sample,
    }

    requestAccessComponents: IResourceTypeComponents = {
        cardComponent: Sample,

        rowComponent: Sample,

        detailComponent: Sample,
    }

    filters = []

    attributes = []

    cartComponent = null

    alreadyInCart: AlreadyInCartType = (
        cartItems: ICartItem[],
        resource: IResource,
        location: any,
    ) =>
        cartItems.find(
            (c) =>
                c.requestableResourceId === resource.id &&
                c.locationId === location?.id,
        ) !== undefined
}
